/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Einvoice_Draft_Total_DiscountInputs */

const vi_einvoice_draft_total_discount = /** @type {(inputs: Einvoice_Draft_Total_DiscountInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Tổng chiết khấu`)
};

/**

* @param {Einvoice_Draft_Total_DiscountInputs} inputs
* @param {{ locale?: "vi" }} options
* @returns {LocalizedString}
*/
export const einvoice_draft_total_discount = /** @type {((inputs?: Einvoice_Draft_Total_DiscountInputs, options?: { locale?: "vi" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Einvoice_Draft_Total_DiscountInputs, { locale?: "vi" }, {}>} */ ((inputs = {}, options = {}) => {
	experimentalStaticLocale ?? options.locale ?? getLocale()
	return vi_einvoice_draft_total_discount(inputs)
});